import { useAtom } from 'jotai'
import { LucideLayers } from 'lucide-react'
import { useMemo } from 'react'
import { aLayersIsOpen } from '~/atoms'
import { ControlTooltip } from '~/components/common'
import {
  Button,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '~/components/ui'
import type { Client } from '~/models'
import { MapGeographiesControl, MapParcelDataControl } from './layers'

type LayersSheetProps = {
  client: Client
}

export default function LayersSheet({ client }: LayersSheetProps) {
  const [isOpen, setIsOpen] = useAtom(aLayersIsOpen)

  const showLayers = useMemo(
    () => client.parcel_data_enabled || client.layers_enabled,
    [client]
  )

  if (!showLayers) {
    return null
  }

  return (
    <Sheet
      modal={false}
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open)
      }}>
      <ControlTooltip text="Toggle Layers" side="bottom">
        <SheetTrigger asChild>
          <Button variant="map" className="relative px-3 shadow-md">
            <LucideLayers className="h-4 w-4" />
            <span className="ml-2">Layers</span>
          </Button>
        </SheetTrigger>
      </ControlTooltip>
      <SheetContent className="flex w-full flex-col" side="right">
        <SheetHeader>
          <SheetTitle>Layers</SheetTitle>
          <SheetDescription>
            Toggle layers visible to show on map.
          </SheetDescription>
        </SheetHeader>
        <div className="flex grow flex-col gap-4 overflow-y-auto">
          {client?.parcel_data_enabled && <MapParcelDataControl />}
          <MapGeographiesControl client={client} />
        </div>
        <div className="flex gap-4 border-t pt-6">
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}
